import http from "./http_common";

class ClinicService {
  queryString(payload) {
    const QueryString = Object.keys(payload).map((key) => (key && payload[key] && key + "=" + payload[key])).join('&');
    return QueryString;
  }

  getClinicList(payload) {
    const queryString = new URLSearchParams(payload).toString();
    return http.get(`/Clinic_Master/list/filter?${queryString}`);
  }

  getClinicListWithType(payload) {
    const queryString = this.queryString(payload);
    return http.get(`/Clinic_Master/list/filter/withAccount?${queryString}`)
  }
  getClinicListCount(payload) {
    const queryString = this.queryString(payload);
    return http.get(`/Clinic_Master/clinicMasterCountStatus?${queryString}`)
  }

  clinicLabMap(payload){
    return http.post('/clinicWithLab/save',payload);
  }

  clinicPharmacyMap(payload){
    return http.post('/clinicWithPharmacy/save',payload);
  }

  getClinicMappedLabs(payload){
    const queryString = this.queryString(payload);
    return http.get(`/clinicWithLab/list/filter?${queryString}`)
  }

  getClinicMappedPharmacies(payload){
    const queryString = this.queryString(payload);
    return http.get(`/clinicWithPharmacy/list/filter?${queryString}`)
  }

  branchActiveInactive(payload){
    return http.put('/Clinic_Master/update/status',payload);
  }

  addClinic(payload) {
    return http.post('/Clinic_Master/save', payload);
  }

  editClinic(payload, id) {
    return http.put(`/Clinic_Master/update/${id}`, payload);
  }

  ClinicFilter(payload) {
    const queryString = Object.entries(payload)
      .filter(
        ([_, value]) => value !== undefined && value !== null && value !== ""
      )
      .map(([key, value]) => `${key}=${value}`)
      .join("&");

    return http.get(`/Clinic_Master/list/filter/withAccount?${queryString}`);
  }

  saveConsulTemplate(data){
    return http.post('/templates/save',data);
  }

  updateConsulTemplate(data){
    return http.put('/templates/update',data);
  }

  getTemplateNameCount(data){
    return http.post('/templates/getTemplateNameCount',data);
  }

  getSavedTempList(data){
    const queryString = this.queryString(data);
    return http.get(`/templates/templatesList/filter?${queryString}`);
  }

  getSelectedTemplate(data){
    const queryString = this.queryString(data);
    return http.get(`/templates/list/filter?${queryString}`);
  }

  generateTemplateId(){
    return http.get('/templates/getNewTemplateId');
  }

  getSpecialityMappedTemp(data){
    const queryString = this.queryString(data);
    return http.get(`/templateSpeciality/list/templatespeciality?${queryString}`);
  }

  specialityTempMapping(data) {
    return http.post('/templateSpeciality/save',data);
  }
}

export default new ClinicService();